import { Entities } from "./globals";

export class Storage {
  cloud: string;
  state: string;
  deployment: string;
  key1: string;
  key2: string;
  location: string;
  name: string;
  sas: string;
  share: string;
  size: number;
  type: string;
  syncStoreUsage: string;
  workStoreUsage: string;
}

export class AzureTransferProgress {
  id: number;
  name: string;
  uploaded: any;
  isUploadComplete: boolean;
  uploadFieldName?: string;
  toShowAtStart?: boolean

  constructor(id: number, key: string, uploaded: any, isUploadComplete: boolean, uploadFieldName: string, toShowAtStart?: boolean) {
    this.id = id
    this.name = key;
    this.uploaded = uploaded;
    this.isUploadComplete = isUploadComplete;
    this.toShowAtStart = toShowAtStart;
  }
}

export class CopyPasteObj {
  SourcePaths: any[];
  DestinationPath: string;

  constructor(sourcePath: [], destinationPath: string) {
    this.SourcePaths = sourcePath;
    this.DestinationPath = destinationPath;
  }
}

export class StorageLogs {
  constructor(
    public uniqueId: number,
    public deployment: string,
    public logType: number, //1 for Upload, 2 for download, 3 for normal
    public fileName: string,
    public actionPath: string,
    public message: string,
    public status: string,
    public showLogActions: boolean,
    public actionTime: string,
    public isRequestCompleted: boolean,
    public toShowAtStart?: boolean,
    public timeRemaining?: number,
    public jobId?: string // Add jobId for on-premise operations
  ) { }
}

export interface OciParModel{
  parId: string,
  parToken: string,
  endpoint: string,
  bucketName: string,
  nameSpace: string,
  expiry: string
}

export interface FileTab {
  deploymentName: string;
  fileName: string;
  filePath: string;
  content: FileTabContent[];
  totalLines: number;
  closed: boolean;
  entityType: Entities;
}

export interface FileTabContent {
  page: number;
  data: string;
}

export enum AzureStorageType {
  TxtFileStorage = "File Storage",
  TxtBlobStorage = "Blob Storage",
  TxtDiskStorage = "Disk Storage",
  TxtQueueStorage = "Queue Storage",
  TxtTableStorage = "Table Storage"
}
